export default class Vector {
    /**
     * 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(x, y) {
        /**
         * @type {number}
         */
        this.x = x;
        /**
         * @type {number}
         */
        this.y = y;
    }

    /**
     * @param {number} x
     * @param {number} y
     */
    set(x, y) {
        this.x = x;
        this.y = y;
    }

    /**
     * @param {Vector} vector
     */
    copy(vector) {
        this.x = vector.x;
        this.y = vector.y;
    }

    /**
     * @this {Vector}
     * @returns {Vector}
     */
    clone() {
        return new Vector(this.x, this.y);
    }

    /**
     * @this {Vector}
     * @param {Vector} vector
     */
    add(vector) {
        this.x += vector.x;
        this.y += vector.y;
    }
    /**
     * @this {Vector}
     * @param {number} x
     * @param {number} y
     */
    addXY(x, y) {
        this.x += x;
        this.y += y;
    }
    /**
     * @this {Vector}
     * @param {Vector} vector
     */
    subtract(vector) {
        this.x -= vector.x;
        this.y -= vector.y;
    }
    /**
     * @param {number} x
     * @param {number} y
     */
    subtractXY(x, y) {
        this.x -= x;
        this.y -= y;
    }

// /**
//  * @param {Vector} vector
//  */
// multiply(vector) {
//     this.x *= vector.x;
//     this.y *= vector.y;
// }
// /**
//  * @param {number} x
//  * @param {number} y
//  */
// multiplyXY(x, y) {
//     this.x *= x;
//     this.y *= y;
// };

// /**
//  * @param {Vector} vector
//  */
// divide(vector) {
//     this.x /= vector.x;
//     this.y /= vector.y;
// }
// /**
//  * @param {number} x
//  * @param {number} y
//  */
// divideXY(x, y) {
//     this.x /= x;
//     this.y /= y;
// }

    /**
     * @param {number} scalar
     */
    scale(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    }

    /**
     * @param {Vector} vector
     * @returns {number}
     */
    distance(vector) {
        const dx = vector.x - this.x;
        const dy = vector.y - this.y;
        return Math.sqrt(dx * dx + dy * dy);
    }

    /**
     * @this {Vector}
     * @param {Vector} vector
     * @returns {number}
     */
    distanceSquared(vector) {
        const dx = vector.x - this.x;
        const dy = vector.y - this.y;
        return dx * dx + dy * dy;
    }

    /**
     * @returns {number}
     */
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }

    /**
     * @returns {number}
     */
    lengthSquared() {
        return this.x * this.x + this.y * this.y;
    }

    /**
     * @param {Vector} vector 
     * @returns {boolean}
     */
    equals(vector) {
        return vector && this.x === vector.x && this.y === vector.y;
    }

    /**
     * @returns {String}
     */
    toString() {
        return '(' + this.x + ', ' + this.y + ')';
    }

    /**
     * @returns {number}
     */
    hash() {
        let hash = 23;
        hash = hash * 31 + this.x;
        hash = hash * 31 + this.y;
        return hash;
    }

    // /**
    //  * @returns {number}
    //  */
    // hash() {
    //     // const temp = this.y + ((this.x + 1) / 2);
    //     // return (this.x + (temp * temp)) | 0;
    // }

    // public int hashCode()
    // {
    //       int tmp = ( y +  ((x+1)/2));
    //                return x +  ( tmp * tmp);
    // }    
}
